// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card__TrialPanel-module--WuGie {
    display: flex;
    flex-direction: column;
    gap: var(--space-md);
    height: 100%;
    padding: var(--space-lg);
    border-radius: var(--home-radius-3xl);
    background: var(--home-color-orange);
    color: var(--color-text-primary);
}

.eyebrow__TrialPanel-module--zCzye {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.heading__TrialPanel-module--cYa07 {
    margin: 0;
    font-size: var(--home-text-heading);
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
}

.body__TrialPanel-module--tZTyA {
    margin: 0;
    font-size: 17px;
    line-height: 1.6;
}

.form__TrialPanel-module--tihtB {
    display: flex;
    flex-direction: column;
    gap: var(--space-2xs);
    margin-top: auto;
}

.fieldLabel__TrialPanel-module--GjDJ_ {
    font-weight: 600;
}

.row__TrialPanel-module--aPzu0 {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-xs);
}

.row__TrialPanel-module--aPzu0 > :first-child {
    flex: 1 1 220px;
    min-width: 0;
}

.submitButton__TrialPanel-module--w46Tn {
    flex-shrink: 0;
}

.alert__TrialPanel-module--RWYPZ {
    margin: 0;
}

.hint__TrialPanel-module--sNj0o {
    margin: 0;
    font-size: 14px;
    line-height: 1.55;
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/TrialPanel.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,wBAAwB;IACxB,qCAAqC;IACrC,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".card {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-md);\n    height: 100%;\n    padding: var(--space-lg);\n    border-radius: var(--home-radius-3xl);\n    background: var(--home-color-orange);\n    color: var(--color-text-primary);\n}\n\n.eyebrow {\n    font-size: 13px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.heading {\n    margin: 0;\n    font-size: var(--home-text-heading);\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    line-height: 1;\n}\n\n.body {\n    margin: 0;\n    font-size: 17px;\n    line-height: 1.6;\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-2xs);\n    margin-top: auto;\n}\n\n.fieldLabel {\n    font-weight: 600;\n}\n\n.row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: var(--space-xs);\n}\n\n.row > :first-child {\n    flex: 1 1 220px;\n    min-width: 0;\n}\n\n.submitButton {\n    flex-shrink: 0;\n}\n\n.alert {\n    margin: 0;\n}\n\n.hint {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.55;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card__TrialPanel-module--WuGie`,
	"eyebrow": `eyebrow__TrialPanel-module--zCzye`,
	"heading": `heading__TrialPanel-module--cYa07`,
	"body": `body__TrialPanel-module--tZTyA`,
	"form": `form__TrialPanel-module--tihtB`,
	"fieldLabel": `fieldLabel__TrialPanel-module--GjDJ_`,
	"row": `row__TrialPanel-module--aPzu0`,
	"submitButton": `submitButton__TrialPanel-module--w46Tn`,
	"alert": `alert__TrialPanel-module--RWYPZ`,
	"hint": `hint__TrialPanel-module--sNj0o`
};
export default ___CSS_LOADER_EXPORT___;
